import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarEmpty } from '@fortawesome/free-regular-svg-icons';
import { GoogleReview } from '../../hooks/useGetGoogleReviews';

interface ReviewCardProps {
    review: GoogleReview;
}

const renderStars = (rating: number) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
        if (i <= rating) {
            stars.push(<FontAwesomeIcon key={i} icon={faStar} />);
        } else if (i === Math.ceil(rating) && !Number.isInteger(rating)) {
            stars.push(<FontAwesomeIcon key={i} icon={faStarHalfAlt} />);
        } else {
            stars.push(<FontAwesomeIcon key={i} icon={faStarEmpty} />);
        }
    }
    return stars;
};

const ReviewCard: React.FC<ReviewCardProps> = ({ review }) => {
    return (
        <div className="review-card">
            <div>
                <div className="review-header">
                    <img src={review.profile_photo_url} alt={review.author_name} className="review-author-photo" />
                    <div className="review-author-info">
                        <h6 className="mb-0">{review.author_name}</h6>
                    </div>
                </div>
                <div className="review-body">
                    <div className="star-rating">{renderStars(review.rating)}</div>
                    {/*<span className="review-time">{review.relative_time_description}</span> */}
                </div>
            </div>
            <p className="review-text mb-0">{review.text}</p>
        </div>
    );
};

export default ReviewCard;